<section class="skeleton-loader-intro" [ngClass]="customStyle">
  <div class="box">
    <div class="box-left">
      <div class="box-left__subheading">
        <ng-container *ngFor="let item of loopArray(customCount.subheading)">
          <div class="skeleton-loader"></div>
        </ng-container>
      </div>

      <div class="box-left__heading">
        <ng-container *ngFor="let item of loopArray(customCount.heading); let i = index">
          <div class="skeleton-loader" [ngStyle]="{ width: 80 - i * 10 + '%' }"></div>
        </ng-container>
      </div>

      <div class="box-left__detail">
        <ng-container *ngFor="let item of loopArray(customCount.detail)">
          <div class="skeleton-loader"></div> </ng-container
      ></div>

      <div class="box-left__btn">
        <div class="box-left__btn--layout">
          <ng-container *ngFor="let item of loopArray(customCount.btn)"
            ><div class="skeleton-loader"></div></ng-container
        ></div>
      </div>
    </div>
    <div class="box-right"><div class="skeleton-loader"></div></div>
  </div>
</section>
